import React, { useState } from 'react';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';

import FilterMenu from './components/FilterMenu';

import { RootContainer, FilterButton } from './styles';

export function SearchAndFilter({
  searchValue,
  setSearchValue,
  filterOptions,
  setFilterOptions,
}) {
  const [filterOpen, setFilterOpen] = useState(false);

  const handleSearchChange = ({ target }) => {
    setSearchValue(target.value);
  };

  const handleFilterClick = () => {
    setFilterOpen((prev) => !prev);
  };

  const handleFilterChange = (field, value) => {
    setFilterOptions({ ...filterOptions, [field]: value });
  };

  const handleApply = (read, date, order) => {
    setFilterOptions({ read, date, order });
    setFilterOpen(false);
  };

  const handleClear = () => {
    setFilterOptions({ read: '', date: '', order: '' });
  };

  const handleClickAway = () => {
    setFilterOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <RootContainer>
        <TextField
          placeholder="Pesquisar"
          variant="outlined"
          fullWidth
          value={searchValue}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />
        <FilterButton
          variant="outlined"
          startIcon={<FilterListIcon />}
          onClick={handleFilterClick}
        >
          Filtro
        </FilterButton>

        {filterOpen && (
          <FilterMenu
            handleFilterChange={handleFilterChange}
            filterOptions={filterOptions}
            handleClear={handleClear}
            handleApply={handleApply}
            setFilterOpen={setFilterOpen}
          />
        )}
      </RootContainer>
    </ClickAwayListener>
  );
}
